export default __webpack_public_path__ + "static/media/BeforePhoto3.7833b7fb.jpg";